import BlogHeading from "../components/Blog/BlogHeading";
import BlogBackMove from "../components/Blog/BlogBackMove";
import BlogStartup from "../components/Blog/BlogStartup";
import Author from "../components/Author";
import BlogCarosuel from "../components/Blog/BlogCarosuel";

const Blog = () => {
  return (
    <>
      <BlogHeading />
      <BlogBackMove move="Blog" />
      <BlogStartup />
      <BlogCarosuel />
      {/* <Author/> */}
    </>
  );
};

export default Blog;
